var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4564_39425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6C4.5 4.34315 5.84315 3 7.5 3H22.5C24.1569 3 25.5 4.34315 25.5 6V9.75C25.5 10.1642 25.1642 10.5 24.75 10.5C24.3358 10.5 24 10.1642 24 9.75V6C24 5.17157 23.3284 4.5 22.5 4.5H7.5C6.67157 4.5 6 5.17157 6 6V15C6 15.8284 6.67157 16.5 7.5 16.5H9.75C10.1642 16.5 10.5 16.8358 10.5 17.25C10.5 17.6642 10.1642 18 9.75 18H7.5C5.84315 18 4.5 16.6569 4.5 15V6Z",
    fill: "#0278AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20.25C3 19.8358 3.33579 19.5 3.75 19.5H9.75C10.1642 19.5 10.5 19.8358 10.5 20.25C10.5 20.6642 10.1642 21 9.75 21H3.75C3.33579 21 3 20.6642 3 20.25Z",
    fill: "#0278AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5135 16.5883L16.5457 14.9414C16.5776 13.3077 17.9111 12 19.5451 12H25.5007C27.1576 12 28.5007 13.3431 28.5007 15V16.5883H30C31.6569 16.5883 33 17.9314 33 19.5883V25.4118C33 27.0686 31.6569 28.4118 30 28.4118V26.9118C30.8284 26.9118 31.5 26.2402 31.5 25.4118V19.5883C31.5 18.7598 30.8284 18.0883 30 18.0883H15C14.1716 18.0883 13.5 18.7598 13.5 19.5883V25.4983C13.5 26.3038 14.1363 26.9656 14.9412 26.9971L15.0294 27.0006L14.9706 28.4994L14.8825 28.496C13.2726 28.4329 12 27.1094 12 25.4983V19.5883C12 17.9314 13.3431 16.5883 15 16.5883H16.5135ZM18.0454 14.9707C18.0613 14.1539 18.7281 13.5 19.5451 13.5H25.5007C26.3292 13.5 27.0007 14.1716 27.0007 15V16.5883H18.0138L18.0454 14.9707Z",
    fill: "#0278AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 28.5C19.5 28.0858 19.8358 27.75 20.25 27.75H24.75C25.1642 27.75 25.5 28.0858 25.5 28.5C25.5 28.9142 25.1642 29.25 24.75 29.25H20.25C19.8358 29.25 19.5 28.9142 19.5 28.5Z",
    fill: "#0278AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 24.75C15 24.3358 15.3358 24 15.75 24H29.2502C29.6644 24 30.0002 24.3358 30.0002 24.75C30.0002 25.1642 29.6644 25.5 29.2502 25.5H28.4207L28.4733 29.9646C28.493 31.6352 27.1442 33 25.4735 33H19.5002C17.8433 33 16.5002 31.6569 16.5002 30V25.5H15.75C15.3358 25.5 15 25.1642 15 24.75ZM18.0002 25.5V30C18.0002 30.8284 18.6717 31.5 19.5002 31.5H25.4735C26.3088 31.5 26.9832 30.8176 26.9734 29.9823L26.9206 25.5H18.0002Z",
    fill: "#0278AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.5C15.3358 19.5 15 19.8358 15 20.25C15 20.6642 15.3358 21 15.75 21H17.25C17.6642 21 18 20.6642 18 20.25C18 19.8358 17.6642 19.5 17.25 19.5H15.75Z",
    fill: "#0278AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4564_39425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLine);
export default __webpack_public_path__ + "static/media/productLine.f45c0e6c9a484efa3df85515484926bd.svg";
export { ForwardRef as ReactComponent };